import './LogsButton.styles.scss';

import { Button } from 'primereact/button';
import React, { FC } from 'react';

import eventLogsStore from '../../../../store/EventLogsStore';
import { TableButtonProps } from '../TableButton.types';

export const LogsButton: FC<TableButtonProps> = ({ tableId, tableDeleted }) => (
  <Button
    className="LogsButton-Component"
    icon="pi pi-stopwatch"
    disabled={tableDeleted}
    rounded
    text
    tooltip="Game events"
    severity="help"
    onClick={() => eventLogsStore.toggleLogVisibility(tableId)}
  />
);
